import type { AppSelectOption } from '../components/form/AppSelectField';

export const filterOptionsByAvailableValues = (
	options: AppSelectOption[],
	availableValues: string[] | undefined,
) => {
	const hasAvailableValues = !!availableValues;

	const filteredOptions = hasAvailableValues
		? options.filter((option) => availableValues.includes(option.value))
		: options;

	return filteredOptions;
};
